import axios from "axios";

/**@Constants */
import { base_URL } from "../config/config";

const API_BASE_URL = `${base_URL}/api/pinned`;

const authHeaders = () => ({
  Authorization: `Bearer ${localStorage.getItem("adminAccessToken")}`,
});

/**
 * The admin authorization middleware answers a permission failure with a 200
 * and an `error` flag, so a successful status code is not proof the write
 * happened.
 */
const unwrap = (data) => {
  if (data?.error) {
    throw new Error(data.message || "You do not have permission to do that");
  }
  return data;
};

const toError = (error, fallback) => {
  const payload = error?.response?.data;
  const failure = new Error(payload?.message || error?.message || fallback);
  // A rejected reorder (409) carries the rail as it actually stands, so the
  // caller can resync from the error instead of firing another request.
  if (Array.isArray(payload?.items)) failure.items = payload.items;
  return failure;
};

export const getPinnedItems = async (section) => {
  try {
    const { data } = await axios.get(`${API_BASE_URL}/${section}`, {
      headers: authHeaders(),
    });
    return unwrap(data)?.items ?? [];
  } catch (error) {
    throw toError(error, "Could not load the pinned listings");
  }
};

export const getPinnableCandidates = async (section, search = "", limit = 24) => {
  try {
    const { data } = await axios.get(`${API_BASE_URL}/${section}/candidates`, {
      params: { limit, ...(search && { search }) },
      headers: authHeaders(),
    });
    return unwrap(data)?.items ?? [];
  } catch (error) {
    throw toError(error, "Could not search listings");
  }
};

export const addPinnedItems = async (section, items) => {
  try {
    const { data } = await axios.post(
      `${API_BASE_URL}/${section}`,
      { items },
      { headers: authHeaders() }
    );
    return unwrap(data);
  } catch (error) {
    throw toError(error, "Could not pin the selected listings");
  }
};

/** `items` is the whole rail in its new order; the server writes 1..N from it. */
export const reorderPinnedItems = async (section, items) => {
  try {
    const { data } = await axios.put(
      `${API_BASE_URL}/${section}/order`,
      { items },
      { headers: authHeaders() }
    );
    return unwrap(data);
  } catch (error) {
    throw toError(error, "Could not save the new order");
  }
};

export const removePinnedItem = async (section, category, id) => {
  try {
    const { data } = await axios.delete(
      `${API_BASE_URL}/${section}/${category}/${id}`,
      { headers: authHeaders() }
    );
    return unwrap(data);
  } catch (error) {
    throw toError(error, "Could not unpin the listing");
  }
};
